import { useState } from 'react';
import { useEventStore } from './event-store';
import { EventCard } from './event-card';
import { coalesceEvents } from './event-coalesce';

const FILTERS = ['all', 'tool-call', 'system', 'cron-result', 'approval-request', 'heartbeat'] as const;
const filterLabels: Record<string, string> = { all: 'All', 'tool-call': 'Tools', system: 'System', 'cron-result': 'Cron', 'approval-request': 'Approvals', heartbeat: 'Heartbeat' };

export function EventPanel() {
  const events = useEventStore((s) => s.events);
  const [filter, setFilter] = useState<string>('all');

  const filtered = filter === 'all' ? events : events.filter((e) => e.type === filter || (filter === 'tool-call' && (e.type === 'tool-start' || e.type === 'server-tool-start' || e.type === 'server-tool-result')));
  const groups = coalesceEvents(filtered);

  return (
    <div className="flex flex-col h-full">
      <div className="px-3 py-2 border-b border-border flex gap-1.5 flex-wrap">
        {FILTERS.map((f) => (
          <button key={f} onClick={() => setFilter(f)} className={`px-2 py-0.5 rounded text-[length:var(--text-2xs)] font-medium transition-colors ${filter === f ? 'bg-primary/20 text-primary border border-primary/40' : 'text-muted-foreground hover:text-muted-foreground'}`}>
            {filterLabels[f]}
          </button>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto p-2 flex flex-col gap-1.5">
        {groups.length === 0 ? (
          <div className="text-muted-foreground text-xs p-2">No events yet</div>
        ) : (
          groups.slice(0, 50).map((g, i) => (
            <EventCard
              key={`${g.lastTimestamp}-${i}`}
              event={{ ...g.event, timestamp: g.lastTimestamp }}
              count={g.count}
            />
          ))
        )}
      </div>
    </div>
  );
}
